<template>
  <div
    class="popular"
    :class="{
      'popular-input': position === 'input',
      'popular-empty': position === 'empty',
    }"
  >
    <div
      v-for="(item, index) in hotKeys?.slice(0, max ? max : hotKeys?.length)"
      :key="index"
      class="tag"
      :title="item"
      @click="select(item)"
    >
      {{ item }}
    </div>
  </div>
</template>

<script setup lang="ts" name="PopularTag">
const emits = defineEmits(['select'])
const props = defineProps<{
  position?: 'input' | 'empty'
  max?: number
  list?: string[]
  source: any
}>()

const select = (item: any) => {
  trackEvent(TRACK_EVENT.CLICK_HOT_KEYWORD_SEARCH, {
    source: props.source,
    keywords: item,
  })

  emits('select', item)
}

const hotKeys = computed(() => (props?.list?.length ? props.list : []))
</script>

<style lang="scss" scoped>
.popular {
  @apply flex-y-center gap-[10px] h-[34px] overflow-hidden flex-wrap;
  .tag {
    @apply bg-back-3 rounded-[15px]  text-font-80 text-16 cursor-pointer truncate overflow-hidden;
    display: inline-block;
    padding: 6px 12px;
    &:hover {
      background-color: var(--purple-1);
    }
  }
}
.popular-input {
  @apply flex flex-col gap-[10px] h-full items-start truncate;
  .tag {
    @apply rounded-[15px] block bg-back-2 p-[6px_12px] text-[16px] text-font-80 hover:text-primary truncate max-w-full;
  }
}
.popular-empty {
  // @apply flex flex-col gap-[10px] h-full items-start truncate;
  .tag {
    @apply bg-back-3 rounded-[6px] text-purple-5 text-14 cursor-pointer truncate overflow-hidden;
    display: inline-block;
    padding: 4px 8px;
    &:hover {
      background-color: var(--purple-1);
    }
  }
}
</style>
